import styled from "styled-components";
import { mediaMaxWidth } from "../../../theme/mediaQueriesTemplates";

interface IWrapperProps {
  preview?: boolean;
}

export const Wrapper = styled.div`
  width: 1100px;
  height: 1556px;
  padding: 10px;
  background-color: #fff;
  box-shadow: ${(props: IWrapperProps) =>
    props.preview && "rgb(220,220,220) 0px 0px 15px"};
  position: ${(props: IWrapperProps) => (props.preview ? "absolute" : "fixed")};
  top: 0;
  left: ${(props: IWrapperProps) => (props.preview ? "unset" : "100vw")};
  transform: ${(props: IWrapperProps) =>
    props.preview && "scale(0.5) translateX(-330px) translateY(-45%)"};
  margin-bottom: ${(props: IWrapperProps) => props.preview && "40px"};
  display: flex;
  flex-direction: column;
  pointer-events: none;

  ${mediaMaxWidth.smallDesktop} {
    transform: ${(props: IWrapperProps) =>
      props.preview && "scale(0.45) translateX(-670px) translateY(-56%)"};
  }

  ${mediaMaxWidth.tablet} {
    transform: ${(props: IWrapperProps) =>
      props.preview && "scale(0.35) translateX(-990px) translateY(-85%)"};
  }

  ${mediaMaxWidth.phone} {
    transform: ${(props: IWrapperProps) =>
      props.preview && "scale(0.25) translateX(-1645px) translateY(-142%)"};
  }

  ${mediaMaxWidth.smallPhone} {
    transform: ${(props: IWrapperProps) =>
      props.preview && "scale(0.2) translateX(-2200px) translateY(-190%)"};
  }
`;

export const Inner = styled.div`
  width: 100%;
  height: 100%;
  padding-top: 50px;
`;

interface IChartsProps {
  height?: string;
}

export const Charts = styled.div`
  display: flex;
  flex-direction: row;
  flex: 1;
  height: ${(props: IChartsProps) => props.height && `${props.height}px`};
`;

interface ILogoProps {
  noneSelected: boolean;
}

export const PortalLogo = styled.img`
  position: absolute;
  right: 25px;
  top: 25px;
  width: 200px;
  filter: ${(props: ILogoProps) => props.noneSelected && "grayscale(100%)"};
  opacity: ${(props: ILogoProps) => props.noneSelected && "0.4"};
`;

export const PremiumLogo = styled.img`
  position: absolute;
  right: 25px;
  top: 25px;
  width: 200px;
  filter: ${(props: ILogoProps) => props.noneSelected && "grayscale(100%)"};
  opacity: ${(props: ILogoProps) => props.noneSelected && "0.4"};
`;

export const HhLogo = styled.img`
  position: absolute;
  right: 7px;
  top: 5px;
  width: 240px;
  filter: ${(props: ILogoProps) => props.noneSelected && "grayscale(100%)"};
  opacity: ${(props: ILogoProps) => props.noneSelected && "0.4"};
`;

export const NoneSelected = styled.div`
  text-align: center;
  font-size: 1.6em;
  font-style: italic;
  margin-top: 200px;
  color: #888;
  font-weight: 100;
`;

export const Footer = styled.div`
  border-top: 1px solid #c7c7c7;
  position: absolute;
  bottom: 0px;
  width: calc(100% - 80px);
  left: 0;
  margin: 0 40px;
  padding: 10px 10px 15px 10px;
  display: flex;
  justify-content: space-between;
  font-size: 0.8em;
  color: #777;
`;

export const FooterText = styled.div``;

export const FooterTime = styled.div``;
